import { useQuery } from "@tanstack/react-query"

import {
  fetchAvailablePlans,
  fetchSubscribedPlans,
} from "data/fetch/plans/list"
import { useOnError } from "data/hooks/useOnError"
import logger from "shared/services/logger"

import {
  setDoNotRetryOn404,
  setRetryLimit,
  setStaleTimeInMinutes,
} from "../helpers"
import { queries } from "../keys"

export const usePlansQuery = (userId, enabled = true) => {
  const queryResult = useQuery({
    queryKey: queries.user.plans(userId)._ctx.available.queryKey,
    queryFn: () => fetchAvailablePlans(userId),
    enabled,
    staleTime: setStaleTimeInMinutes(10),
    retry: failureCount => setRetryLimit(failureCount, 5),
  })

  useOnError(queryResult, error => {
    logger(
      "Failed to fetch available plans",
      userId,
      "GTM:Plans view",
      "error",
      error
    )
  })

  return queryResult
}

export const useSubscribedPlansQuery = (userId, enabled = true) => {
  const queryResult = useQuery({
    queryKey: queries.user.plans(userId)._ctx.subscribed.queryKey,
    queryFn: () => fetchSubscribedPlans(userId),
    enabled,
    staleTime: setStaleTimeInMinutes(10),
    retry: (failureCount, error) =>
      setDoNotRetryOn404(error) && setRetryLimit(failureCount, 5),
  })

  useOnError(queryResult, error => {
    if (setDoNotRetryOn404(error))
      logger(
        "Failed to fetch subscribed plans",
        userId,
        "GTM:Plans view",
        "error",
        error
      )
  })

  return queryResult
}

export default {
  usePlansQuery,
  useSubscribedPlansQuery,
}
